import { Box, Typography } from "@mui/material";
import MobileHeader from "./headers/MobileHearder";
import { useContext } from "react";
import { LanguageContext } from "../context/LanguageContext";

export default function AnalyticsMobile() {
  const { translate } = useContext(LanguageContext);

  return (
    <Box
      sx={{
        minHeight: "100vh",
        bgcolor: "background.default",
        color: "text.primary",
      }}
    >
      <MobileHeader title={translate("Analytics")} />
      <Box sx={{ p: 2, pt: 4 }}>
        <Typography variant="body1" sx={{ opacity: 0.8 }}>
          {translate("AnalyticsPagePlaceholder") ||
            "Analytics and reports will be displayed here."}
        </Typography>
      </Box>
    </Box>
  );
}
